
import { defineComponent } from 'vue'

/**
 * 確認メッセージコンポーネント(仮申請(確認)・本申請(確認))
 */
export default defineComponent({
  name: 'JrRegistConfirmMessage',
})
